import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        container: {
            display: 'flex',
            alignItems: 'center',
        },
        icon: {
            paddingRight: theme.spacing(1),
        },
    }
})

export default useStyles
